import { topicPartRepository } from "../../../providers/repositories/topicPartRepository";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const deleteTopicPartUseCase = {
    async exec(id: string | number): Promise<boolean> {
        try {
            await topicPartRepository.delete(id);
            toast.success(t("action.deleteSuccess"));
            return true;
        } catch (error) {
            Logger.error("deleteTopicPartUseCase", error);
            toast.error(t("action.deleteError"));
        }
        return false;
    },
};
